import type ExampleMetaExport from "@/types/examples";

export default {
  displayName: "Touying Demo",
  title: "Touying 模板使用介绍",
  template: "touying",
  description: <></>,
} satisfies ExampleMetaExport;
